export default function Logo({ className = "h-9" }) {
  return <img src="/assets/logo-horizontal.png" alt="OdontoSend" className={`w-auto ${className}`} />;
}
